import { render, staticRenderFns } from "./SignUpContainer.vue?vue&type=template&id=7b8bce33&scoped=true"
import script from "./SignUpContainer.vue?vue&type=script&lang=js"
export * from "./SignUpContainer.vue?vue&type=script&lang=js"
import style0 from "./SignUpContainer.vue?vue&type=style&index=0&id=7b8bce33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8bce33",
  null
  
)

export default component.exports